export const INITIAL_DEFAULT_LIMIT_MIN = 8;
export const INITIAL_DEFAULT_LIMIT = 25;
export const INITIAL_DEFAULT_OFFSET = 0;
export const INITIAL_DEFAULT_PAGE = 1;
